(function () {
  const CART_UPDATE_EVENT = 'wetheme-cart-update';
  const GOODIE_REMOVE_SELECTOR = '[data-cart-progress-goodie-remove="true"]';
  const SUPPRESSED_STORAGE_KEY = 'cartProgressGoodieSuppressedVariantId';
  let syncing = false;

  function getGoodieConfig() {
    const globalEl = document.querySelector('#wetheme-global');
    if (!globalEl) return {};

    try {
      const global = JSON.parse(globalEl.textContent);
      return global.cartProgressGoodie || {};
    } catch (error) {
      console.warn('Invalid cart progress goodie config', error);
      return {};
    }
  }

  function getCartTotalWithoutGoodie(cart, goodieItem) {
    const goodieLinePrice = goodieItem ? goodieItem.final_line_price || goodieItem.line_price || 0 : 0;
    return cart.total_price - goodieLinePrice;
  }

  function getSuppressedGoodieVariantId() {
    try {
      return Number(window.sessionStorage.getItem(SUPPRESSED_STORAGE_KEY)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function suppressGoodieVariant(goodieVariantId) {
    try {
      window.sessionStorage.setItem(SUPPRESSED_STORAGE_KEY, String(goodieVariantId));
    } catch (error) {
      return;
    }
  }

  function clearSuppressedGoodieVariant() {
    try {
      window.sessionStorage.removeItem(SUPPRESSED_STORAGE_KEY);
    } catch (error) {
      return;
    }
  }

  async function fetchSyncedCart() {
    const pageContainer = document.querySelector('#PageContainer');
    const languageUrl = pageContainer ? pageContainer.dataset.languageUrl : '';
    const languageParam = !languageUrl || languageUrl === '/' ? '' : languageUrl;
    const response = await window.fetch(`${languageParam}/cart?view=compare`);

    if (!response.ok) return null;
    return response.json();
  }

  async function syncCartProgressGoodie(cart) {
    const goodie = getGoodieConfig();
    const goodieVariantId = Number(goodie.variantId);
    const goodieThreshold = Number(goodie.threshold) || 0;

    if (!goodie.enabled || !goodieVariantId || goodieThreshold <= 0 || !cart || !Array.isArray(cart.items)) return;
    if (syncing) return;

    const goodieLineIndex = cart.items.findIndex(item => Number(item.variant_id || item.id) === goodieVariantId);
    const goodieItem = goodieLineIndex > -1 ? cart.items[goodieLineIndex] : null;
    const goodieLine = goodieLineIndex + 1;
    const shouldHaveGoodie = getCartTotalWithoutGoodie(cart, goodieItem) >= goodieThreshold;
    const isGoodieSuppressed = getSuppressedGoodieVariantId() === goodieVariantId;
    let response;

    if (!shouldHaveGoodie) {
      clearSuppressedGoodieVariant();
    }

    if (shouldHaveGoodie && !goodieItem && isGoodieSuppressed) return;

    try {
      syncing = true;

      if (shouldHaveGoodie && !goodieItem) {
        response = await window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: goodieVariantId,
            quantity: 1
          })
        });
      } else if (shouldHaveGoodie && goodieItem.quantity !== 1) {
        response = await window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: goodieLine,
            quantity: 1
          })
        });
      } else if (!shouldHaveGoodie && goodieItem) {
        response = await window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: goodieLine,
            quantity: 0
          })
        });
      }

      if (response && response.ok) {
        const syncedCart = await fetchSyncedCart();
        syncing = false;

        if (syncedCart && window.wetheme && window.wetheme.updateCartDrawer) {
          window.wetheme.updateCartDrawer(syncedCart);
        }

        return;
      }
    } catch (error) {
      console.error('Unable to sync cart progress goodie: ', error);
    }

    syncing = false;
  }

  document.documentElement.addEventListener(CART_UPDATE_EVENT, event => {
    if (event.detail && event.detail.cart) {
      syncCartProgressGoodie(event.detail.cart);
    }
  });

  document.documentElement.addEventListener('click', event => {
    const removeButton = event.target.closest(GOODIE_REMOVE_SELECTOR);
    if (!removeButton) return;

    const goodieVariantId = Number(getGoodieConfig().variantId);
    if (goodieVariantId) {
      suppressGoodieVariant(goodieVariantId);
    }
  });
})();
